import React from 'react'

const Columns = ({ children }) => <div className="columns">{children}</div>

const Column = ({ width, children }) => <div className={`column ${width ? `is-${width}` : ''}`}>{children}</div>

const Section = ({ children }) => <div className="section">{children}</div>

export { Columns, Column, Section }
